import React from "react";
import { Row } from "react-bootstrap";
import { i18n } from "app/i18n/i18n";
import { AdvertCardCol } from "pages/Ads/Adverts/AdvertCard";
import { PublicationCard } from "../PublicationCard/PublicationCard";
import { NoPublicationsFound } from "../ViewLayout/ViewLayout";
import { cardStyles } from "./styles";
import { existsHtmlFormat } from "utils/publications";

export function TileView({ publications = [] }) {
  const lang = i18n.getLanguage();
  if (!publications.length) return <NoPublicationsFound />;

  return (
    <Row className="mx-n2">
      {publications.map((publication) => {
        switch (publication.cardType) {
          case "podcast":
            return (
              <PublicationCard key={publication.id} publication={publication} styles={cardStyles.podcast} lang={lang} />
            );

          case "advert":
            return <AdvertCardCol key={publication.id} {...publication} />;

          default: {
            const styles = getPublicationStyles(publication);
            return <PublicationCard key={publication.id} publication={publication} styles={styles} lang={lang} />;
          }
        }
      })}
    </Row>
  );
}

function getPublicationStyles(publication) {
  let style = publication.style ? cardStyles[publication.style] : cardStyles.default;
  const hasCoverImage = getCoverImage(publication);

  if ((isAnchorReport(publication) && existsHtmlFormat(publication)) || hasCoverImage) {
    style = cardStyles.coverImage(publication.id);
  }

  return style;
}

export function isAnchorReport(publication) {
  const isAnchor =
    publication?.reportTypes && publication?.reportTypes.find((reportType) => reportType.en.includes("Anchor Report"));
  return isAnchor;
}

export function getCoverImage(publication) {
  return publication?.customData?.coverImage;
}
